export const filters = [
  {
    name: "Diese Woche",
    value: "currentWeek",
  },
  {
    name: "Dieser Monat",
    value: "currentMonth",
  },
  {
    name: "Voriger Monat",
    value: "lastMonth",
  },
  {
    name: "Vorige Woche",
    value: "lastWeek",
  },
];
